module.exports = __webpack_public_path__ + "static/bed-frame-4-7bfe37610a6853ff6489f9055c26422b.png";